import { cn } from '@/lib/utils'

/**
 * The run-details panel's section heading — mono, uppercase, wide-tracked.
 *
 * Shared rather than repeated so the panel's sections can't drift apart from
 * each other: the modal already supplies the framing, so a section that
 * brought its own card heading instead would read as a card nested inside a
 * card.
 */
export function SectionLabel({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        'text-text-mute font-mono text-[10px] uppercase tracking-[0.16em]',
        className,
      )}
    >
      {children}
    </span>
  )
}

export default SectionLabel
